import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { InputFieldState } from '../types';
import options from './options.json';

/**
 * SpecialNotesOnFeeFormコンポーネント用のPropsです。
 * @interface SpecialNotesOnFeeFormProps
 */
interface SpecialNotesOnFeeFormProps {

  /**
   * 手数料に関する特記事項
   * @type {InputFieldState}
   * @memberof SpecialNotesOnFeeFormProps
   */
  specialNotesOnFee: {
    parentItem: InputFieldState;
    childItem: InputFieldState;
  };

  /**
   * 手数料に関する特記事項を設定する関数
   * @memberof SpecialNotesOnFeeFormProps
   */
  onChange: (date: {
    parentItem: InputFieldState;
    childItem: InputFieldState;
  }) => void;
  
}

/**
 * 手数料に関する特記事項フォームのコンポーネントです。
 * @param {string} props.specialNotesOnFee - 表示する手数料に関する特記事項
 * @param {function} props.onChange - 手数料に関する特記事項が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 手数料に関する特記事項フォームのJSX要素
 */
const SpecialNotesOnFeeForm: React.FC<SpecialNotesOnFeeFormProps> = ({ specialNotesOnFee, onChange }) => {

  const [childItems, setChildItems] = useState<{label: string, value: string}[]>([]);


  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 入力された識別番号を整形し、onChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleParentItemChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    options.forEach((item, _index) => {
      if(item.parentItem.value === value) {
        setChildItems(item.childItems);
        onChange({
          parentItem: {
            value: value,
            errorMessage: ''
          },
          childItem: {
            value: item.childItems.length !== 0 ? item.childItems[0].value : '',
            errorMessage: ''
          },
        });
      }
    })
  };

  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 入力された識別番号を整形し、onChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleChildItemChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    onChange({
      parentItem: {
        value: specialNotesOnFee.parentItem.value,
        errorMessage: ''
      },
      childItem: {
        value: value,
        errorMessage: ''
      },
    });
  };


  return (
    <Form.Group className="mb-3 row">
      <Form.Label className="col-lg-2 col-12">
        特許料等に関する特記事項
        <span className="text-small text-secondary ms-3">※任意</span>
      </Form.Label>
      <div className="col-lg-10 col-12 ps-lg-5">
        <div className="row">
          <div className="col-10">
            <Form.Select onChange={handleParentItemChange} aria-label="特許料等に関する特記事項" value={specialNotesOnFee.parentItem.value}>
              {
                options.map((option, index) => {
                  return <option key={index} value={option.parentItem.value}>{option.parentItem.label}</option>
                })
              }
            </Form.Select>
          </div>
          <div className="col-2">
            <Form.Select className="col-2" onChange={handleChildItemChange} aria-label="特許料等に関する特記事項" value={specialNotesOnFee.childItem.value} disabled={childItems.length === 0 ? true : false}>
              {
                childItems.map((option, index) => {
                  return <option key={index} value={option.value}>{option.label}</option>
                })
              }
            </Form.Select>
          </div>
        </div>
        {specialNotesOnFee.parentItem.errorMessage !== '' ? <div className="text-end text-danger small">{specialNotesOnFee.parentItem.errorMessage}</div> : ''}
        {specialNotesOnFee.childItem.errorMessage !== '' ? <div className="text-end text-danger small">{specialNotesOnFee.childItem.errorMessage}</div> : ''}

      </div>
    </Form.Group>
  );
}

export default SpecialNotesOnFeeForm;